import { combineReducers } from '@reduxjs/toolkit';
import { principalsReducer } from './principals/principals.reducer';
import { userReducer } from './user/user.reducer';

export const rootReducer = combineReducers({
  user: userReducer,
  principals: principalsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
